
import { defineComponent } from "vue";
import {
  process_matchinpayOTP,
  loadPaginatedMatchinPayHistory,
  process_matchinpayReload,
  process_matchinpayReload_DLQR,
} from "@/api/matchinpay";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import OtpInput from "@/components/encashment/OtpInput.vue";
import StatCard from "@/components/dashboard/sequence/StatCard.vue";
import { getBalanceDetails } from "@/api/dashboard";
import { getCurrentUser } from "@/utils/index";

export default defineComponent({
  name: "matchinpayprocess",
  components: {
    OtpInput,
    StatCard,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      hasPendingMatchinPayOTP: false,
      totalAmount: "0",
      totalAmount2: 0,
      model_matchinpay_otp: "",
      isProcessingOTP: false,
      isProcessingReload: false,
      loading: true,
      loadingBalance: true,
      topupfrom: 0,
      qrcodeFromQRPh: "",
      isShowProceed: false,
      currency: "",
      isAllowedMatchinPay: false,
      amounts: [2000, 5000],
      balancedetails: {} as any,
      user: {} as any,
    };
  },
  methods: {
    selectTopUpFrom() {
      this.resetForm();
    },
    async getBalanceDetails() {
      this.loadingBalance = true;
      const response = await getBalanceDetails();
      this.balancedetails = response.data;
      this.loadingBalance = false;
    },
    async loadPaginatedMatchinPayHistory() {
      this.loading = true;
      const response = await loadPaginatedMatchinPayHistory(1);
      this.hasPendingMatchinPayOTP = response.data.hasPendingMatchinPayOTP;
      this.currency = response.data.currency;
      this.isAllowedMatchinPay = response.data.isShowMatchinPayReloadDiv;
      this.loading = false;
    },
    async resetForm() {
      this.totalAmount = "0";
      this.totalAmount2 = 0;
      this.isShowProceed = false;
    },
    async cancel_matchinpayReload() {
      this.resetForm();
      this.topupfrom = 0;
    },
    async computeTotalAmount(amountClicked: number) {
      var totalAmount = Number(amountClicked);

      if (totalAmount > 0) {
        this.isShowProceed = true;
      } else {
        this.isShowProceed = false;
      }

      this.totalAmount2 = totalAmount;
      this.totalAmount = String(totalAmount);
      return totalAmount;
    },
    async process_matchinpayReload() {
      this.loading = true;
      if (isNaN(this.totalAmount2) || this.totalAmount2 == 0) {
        this.isProcessingReload = true;
        Swal.fire({
          title: "",
          text: "Total must be greater than 0.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        this.isProcessingReload = false;
      } else {
        this.isProcessingReload = true;
        var param = { amount: this.totalAmount2 };
        const response = await process_matchinpayReload(param);

        if (response != null) {
          this.isProcessingReload = false;
          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
            });
            window.location.reload();
          } else if (response.data.result == "FAILED") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
            });
          }
        }
      }
      this.loading = false;
    },
    async process_matchinpayReload_DLQR() {
      this.loading = true;
      if (isNaN(this.totalAmount2) || this.totalAmount2 == 0) {
        this.isProcessingReload = true;
        Swal.fire({
          title: "",
          text: "Total must be greater than 0.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        this.isProcessingReload = false;
        this.loading = false;
        return false;
      } else {
        this.isProcessingReload = true;
        var param = { amount: this.totalAmount2 };
        const response = await process_matchinpayReload_DLQR(param);

        if (response != null) {
          if (response.data.result == "SUCCESS") {
            this.qrcodeFromQRPh = response.data.qrCode;

            if (this.qrcodeFromQRPh !== "") {
              this.$router.push({
                name: "mgpaygenerateqr",
                params: { qrCode: this.qrcodeFromQRPh },
              });
            }
          } else if (response.data.result == "FAILED") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
            });
            this.loading = false;
            return;
          }
        }
        this.isProcessingReload = false;
      }
      this.loading = false;
    },
    async process_matchinpayOTP() {
      this.loading = true;
      this.isProcessingOTP = true;
      var param = { otp: this.model_matchinpay_otp };
      const response = await process_matchinpayOTP(param);
      if (response != null) {
        this.isProcessingOTP = false;

        if (response.data.result == "SUCCESS") {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
          window.location.reload();
          return;
        } else if (response.data.result == "FAILED") {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          this.loading = false;
          return;
        }
      }
      this.loading = false;
    },
  },
  mounted() {
    this.user = getCurrentUser();
    this.loadPaginatedMatchinPayHistory();
    this.getBalanceDetails();
  },
});
